import axios from 'axios'
import { CENTRIC_API, GECKO_API } from 'constants/config'
import { ApiCNRPriceResponse, ApiInfoResponse, GeckoCNSPriceResponse } from './types'

export const getApiCNRPrice = async (): Promise<ApiCNRPriceResponse> => {
  const url = `${CENTRIC_API}/public/bsc/contract/price`
  const { data } = await axios.get(url)

  return data
}

export const getApiInfo = async (): Promise<ApiInfoResponse> => {
  const url = `${CENTRIC_API}/public/bsc/contract/info`
  const { data } = await axios.get(url)

  return data
}

export const getGeckoCNSPrice = async (): Promise<GeckoCNSPriceResponse> => {
  const url = `${GECKO_API}/v3/simple/price?ids=centric-cash&vs_currencies=usd`
  const { data } = await axios.get(url)

  return data
}
